module.exports = __webpack_public_path__ + "static/media/Slark.8978b2e7.png";